import axios from "axios";
import { backendUri } from "@/utils/settings";

const getShop = async () => {
  return await axios.get(backendUri + "api/game/ext/shop/");
};

export { getShop }